<template>
  <input type="text" ref="dateinput" tabindex="0" :disabled="disabled" :value="value" @input="onEditInput"/>
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";
import AirDatepicker from 'air-datepicker'
import localeEn from 'air-datepicker/locale/en';
import localeRu from 'air-datepicker/locale/ru';
import 'air-datepicker/air-datepicker.css'

@Component({
  name: "PayoutDateInput"
})
export default class PayoutDateInput extends Vue {

  @Prop({default: false})
  disabled: boolean

  @Prop({default: null})
  initValue: string | null

  @Prop({default: null})
  value: string | null

  @Prop({
    default: function () {
      return {
        range: false,
        dateFormat: 'yyyy-MM-dd',
        minDate: new Date(1911, 0, 0),
        maxDate: new Date(),
        view: 'years', minView: 'days',
        autoClose: true,
        //language: //document.getElementsByTagName("html")[0].getAttribute("lang")
      }
    }
  })
  pickerOptions: any

  picker: AirDatepicker | null = null

  get currentLang() {
    return this.$i18n.locale;
  }

  get currentLocale() {
    return this.currentLang === 'en' ? localeEn : localeRu;
  }

  get actualConfig() {
    return Object.assign(this.defaultOptions, this.pickerOptions, {
      onSelect: this.onSelect,
      language: this.currentLang,
      locale: this.currentLocale
    });
  }

  @Watch('actualConfig', {deep: true})
  onConfigUpdate() {
    this.picker.update(this.actualConfig);
  }

  defaultOptions = {
    keyboardNav: false
  }

  mounted() {
    this.picker = new AirDatepicker(this.$refs.dateinput as HTMLInputElement, this.actualConfig);
    if (this.initValue)
      this.picker.selectDate(this.initValue);
  }

  onEditInput($event: any) {
    this.$emit('input', $event.target.value);
  }

  onSelect({formattedDate}): any {
    if (formattedDate)
      this.$emit('input', formattedDate);
  }

  selectDate(period: any): void {
    this.picker.selectDate(period);
  }
}
</script>

<style scoped>

</style>
